// extracted by mini-css-extract-plugin
module.exports = {"shortAddress":"ShortAddress_shortAddress__16h3M","mobileText":"ShortAddress_mobileText__2go5K"};